// extracted by mini-css-extract-plugin
export default {"view":"news_view__SjlWz"};